import { Team } from "@redotech/redo-model/team";

export const getPdpUrl = (
  team: Team,
  productHandle: string,
  variantId?: string,
) => {
  return `https://${team?.storeUrl}/products/${productHandle}${variantId ? `?variant=${variantId}` : ""}`;
};
